import { type FormValidationError, type ValidationError } from "@tanstack/react-form";
import { type ArrayOrSingle } from "ts-essentials";
import { getArrayOrSingle } from "@/utils/functions/get-array-or-single";

export function getErrorText<TFormData>({
  language,
  errors = [],
}: {
  language: string;
  errors: ArrayOrSingle<FormValidationError<TFormData>>;
}): string {
  const formatter = new Intl.ListFormat(language, { type: "conjunction" });
  const messages = getArrayOrSingle(errors)
    .map((error) => {
      if (typeof error === "string") {
        return error;
      } else if (error && typeof error === "object" && "message" in error) {
        return error.message;
      }

      return JSON.stringify(error);
    })
    .filter((error): error is string => !!error);

  if (messages.length === 0) {
    return "";
  }

  // Deduplicate error messages
  const uniqueMessages = Array.from(new Set(messages));

  return formatter.format(uniqueMessages);
}
